<template>
  <div class="allocatedBox">
    <!-- 头部筛选 -->
    <el-form :inline="true" :model="form" class="filterContent">
      <el-form-item label="负责人:">
        <el-select
          v-model="form.principal_name"
          popper-class="allocated-mySelectOptions"
          filterable
          remote
          clearable
          placeholder="请输入负责人姓名"
          :remote-method="remotePrincipalMethod"
          :loading="remotePrincipalLoading"
          @clear="principalOptions = []"
        >
          <el-option
            v-for="item in principalOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
            <p class="labelText">{{ item.label }}</p>
            <p class="weakText">{{ item.info }}</p>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="负责人ID:">
        <el-input v-model="form.principal_userid" clearable placeholder="请输入负责人ID"></el-input>
      </el-form-item>
      <el-form-item label="医院:">
        <el-input
          v-model="form.hospital_name"
          :clearable="true"
          placeholder="请输入医院名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="科室:">
        <el-select v-model="form.department_name" clearable placeholder="请选择科室名称">
          <el-option
            v-for="item in departmentOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="医生:">
        <el-input
          v-model="form.doctor_name"
          :clearable="true"
          placeholder="请输入医生名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">搜索</el-button>
      </el-form-item>
    </el-form>
    <div class="buttonList">
      <div class="leftContent">已分配客户：包括在职成员的所有客户列表</div>
      <div class="rightContent">
        <el-button
          class="filterButton"
          type="primary"
          :disabled="!multipleSelection.length"
          @click="clickAllot"
        >
          分配
        </el-button>
        <el-button class="filterButton" @click="clickToViewRecord">查看分配记录</el-button>
        <el-button class="filterButton" @click="exportExcel">导出数据</el-button>
        <ExportProgress ref="downloadDialog"></ExportProgress>
      </div>
    </div>
    <!-- 列表 -->
    <div class="listContent">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <template slot="empty">
          <!-- 没有数据 -->
          <NoData></NoData>
        </template>
        <el-table-column
          type="selection"
          width="55"
          :selectable="checkBoxDisable"
        ></el-table-column>
        <el-table-column prop="custom_name" label="客户名称"></el-table-column>
        <el-table-column prop="doctor_name" label="医生"></el-table-column>
        <el-table-column prop="hospital_name" label="医院" width="400"></el-table-column>
        <el-table-column prop="department_name" label="科室">
          <template slot-scope="scope">
            <span>{{ scope.row.department_name || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="principal_name" label="负责人"></el-table-column>
        <el-table-column prop="principal_userid" label="负责人ID"></el-table-column>
        <el-table-column prop="tips" label="备注" width="240">
          <template slot-scope="scope">
            <span>
              {{
                statusMap[scope.row.status] === '等待接替'
                  ? `${scope.row.takeover_time}交接给${scope.row.takeover_username}`
                  : statusMap[scope.row.status] || '--'
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="添加时间">
          <template slot-scope="scope">
            <span>
              {{
                scope.row.create_time
                  ? dateFormat(new Date(scope.row.create_time), 'YYYY-MM-dd HH:mm:SS')
                  : '--'
              }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="tableData.length > 0"
        class="pagination"
        style="background-color: #ffffff"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="g_pageSizesConfig"
        :total="total"
        :page-size="size"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      ></el-pagination>
    </div>
    <PopAllocation
      v-if="isShowAllocation"
      :customers="multipleSelection"
      :dialog-table-visible="isShowAllocation"
      @hidePop="hidePopMe"
      @onSubmit="onSubmit"
    />
    <!-- 二次确认弹窗 -->
    <ConfirmDialog
      :ptype="0"
      :submit-parmas="submitParmas"
      :dialog-table-visible="isShowConfirmDialog"
      @hidePop="isShowConfirmDialog = false"
      @onSuccess="onConfirmSuccess"
    />
  </div>
</template>
<script>
import PopAllocation from './PopAllocation.vue';
import ConfirmDialog from './confirmDialog.vue';
import ExportProgress from '@/components/export-progress';
import { dateFormat } from '@/utils/time';
import NoData from '@/components/no-data';
import {
  getPrincipalInfoListApi,
  getExternalContactListApi,
  ExportExternalContact,
} from '@/api/enterpriseWeChatManagement';
import { getHospitalDepartmentListApi } from '@/api/setUp';

export default {
  name: 'Allocated',
  components: {
    PopAllocation,
    ConfirmDialog,
    NoData,
    ExportProgress,
  },
  data() {
    return {
      dateFormat,
      multipleSelection: [], // 选择集合
      principalOptions: [],
      remotePrincipalLoading: false,
      form: {
        doctor_name: '',
        hospital_name: '',
        department_name: '',
        principal_name: '',
        principal_userid: '',
      },
      tableData: [] /* 表格数据 */,
      currentPage: 1 /* 当前页面数 */,
      size: this.g_pageSizeDefault /* 当前页面显示数目 */,
      total: 0 /* 总数 */,
      isShowAllocation: false /* 是否显示分配弹窗 */,
      isShowConfirmDialog: false,
      submitParmas: {},
      loading: false,
      departmentOptions: [],
      statusMap: {
        1: '接替完毕',
        2: '等待接替',
        3: '客户拒绝',
        4: '接替成员客户达到上限',
        5: '无接替记录',
      },
    };
  },
  created() {
    this.getTableData();
    this.getDepartmentList();
  },
  methods: {
    async getTableData() {
      this.loading = true;
      const params = {
        ...this.form,
        principal_userid: this.form.principal_userid ? [this.form.principal_userid] : [],
        ptype: 0, // 客户类型(0已分配客户 1待分配客户)
        page: this.currentPage,
        limit: this.size || this.g_pageSizeDefault,
      };
      try {
        const res = await getExternalContactListApi(params);
        this.tableData = res.list;
        this.total = res.total;
      } catch (err) {
        this.tableData = [];
        this.total = 0;
      }
      this.loading = false;
    },
    async getDepartmentList() {
      try {
        const res = await getHospitalDepartmentListApi({
          hospital_id: 0,
          page_index: 0,
          page_size: 0,
        });
        if (res.data && res.data.length) {
          this.departmentOptions = res.data.map((item) => ({
            label: item.department_name,
            value: item.department_name,
          }));
        }
      } catch (err) {
        console.log('error', err);
      }
    },
    /* 负责人列表 */
    async getPrincipalInfo(name = '') {
      this.remotePrincipalLoading = true;
      const params = {
        name,
      };
      try {
        const res = await getPrincipalInfoListApi(params);

        this.principalOptions = res.list.map((item) => ({
          label: item.name,
          info: item.department_name,
          value: item.name,
        }));
      } catch (err) {
        this.principalOptions = [];
      }
      this.remotePrincipalLoading = false;
    },
    remotePrincipalMethod(query) {
      if (query === '') {
        this.principalOptions = [];
        return;
      }
      this.getPrincipalInfo(query);
    },
    /* 搜索 */
    onSearch() {
      this.currentPage = 1;
      this.getTableData();
    },
    /* 表格多选 */
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    checkBoxDisable(row) {
      return this.statusMap[row.status] !== '等待接替';
    },
    /* 切换分页 */
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    handleSizeChange(size) {
      this.size = size;
      this.getTableData();
    },
    hidePopMe() {
      this.isShowAllocation = false;
    },
    /* 查看分配记录 */
    clickToViewRecord() {
      this.$emit('showRecords', { custom_type: 0 });
    },
    clickAllot() {
      this.isShowAllocation = true;
    },
    onSubmit(params) {
      this.submitParmas = params;
      this.isShowConfirmDialog = true;
    },
    onConfirmSuccess() {
      this.isShowConfirmDialog = false;
      this.isShowAllocation = false;
      this.currentPage = 1;
      this.getTableData();
    },
    exportExcel() {
      this.$refs.downloadDialog.openDialog();
      ExportExternalContact({
        ptype: 0,
      })
        .then((res) => {
          this.$refs.downloadDialog.finishProgress(1000);
          setTimeout(() => {
            this.g_tourl(res.url, { open: true });
          }, 1000);
        })
        .catch((e) => {
          this.$refs.downloadDialog.abortProgress();
          this.$message.error(e);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.allocatedBox {
  .filterContent {
    padding: 30px 0 0 0;
    border-bottom: 1px solid #eee;
  }
  .buttonList {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 16px 0;
    .leftContent {
      font-size: 16px;
      color: #313233;
    }
  }
  .pagination {
    text-align: right;
    margin: 10px 0;
  }
}
</style>
<style lang="scss">
// .allocated-mySelectOptions {
//   ::v-deep.el-select-dropdown__item {
//     height: 57px;
//     text-overflow: initial;
//     white-space: initial;
//     .labelText {
//       font-family: PingFangSC-Regular;
//       font-size: 16px;
//       color: #303133;
//     }
//     .weakText {
//       font-family: PingFangSC-Regular;
//       font-size: 14px;
//       color: #909399;
//       line-height: 14px;
//       overflow: hidden;
//       text-overflow: ellipsis;
//       white-space: nowrap;
//     }
//   }
// }
</style>
